import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledSelfServiceSolution = styled(Box)(({ theme }) => ({
    // minHeight: '100vh',
    // height: '100%',
    // position: 'relative',
    // overflow: 'visible',

    [theme.breakpoints.down('md')]: {
        '& .background': {
            '@media (min-width: 320px)': {
                height: '535px !important'
            },
        },
        '& .wave1': {
            '@media (min-width: 320px)': {
                marginTop: '505px !important'
            },
        },
        '& .wave2': {
            '@media (min-width: 320px)': {
                marginTop: '533px !important'
            },
        }
    },
}));

export default StyledSelfServiceSolution;
